import React, { FC, useMemo } from 'react'
import { Tag, TAG_SIZE, TAG_STYLE } from 'transfix-ui/components/Tag'
import { Box, makeStyles, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { BookableShipmentSavedSearch } from 'apps/fleet-planner/types'

interface BookableShipmentSavedSearchAlertRowLoadCountsProps {
  savedSearch: BookableShipmentSavedSearch
}

const useStyles = makeStyles(() => ({
  found: {
    color: brandColors.info,
  },
  notFound: {
    color: brandColors.coolGray5,
  },
}))

export const BookableShipmentSavedSearchAlertRowLoadCounts: FC<BookableShipmentSavedSearchAlertRowLoadCountsProps> = ({
  savedSearch,
}) => {
  const styles = useStyles()
  const unviewedResultCountStr = useMemo(() => {
    const { unviewedResultCount } = savedSearch
    if (!unviewedResultCount) return ''
    return `${unviewedResultCount} new`
  }, [savedSearch])

  const totalResultCountStr = useMemo(() => {
    const { totalResultCount } = savedSearch
    return totalResultCount === 1
      ? `${totalResultCount} available load`
      : `${totalResultCount} available loads`
  }, [savedSearch])

  return (
    <Box display='flex' alignItems='center'>
      {unviewedResultCountStr && (
        <Box mr={2}>
          <Tag label={unviewedResultCountStr} size={TAG_SIZE.small} tagStyle={TAG_STYLE.info} />
        </Box>
      )}
      <Typography
        variant='body2'
        className={savedSearch.totalResultCount ? styles.found : styles.notFound}>
        {totalResultCountStr}
      </Typography>
    </Box>
  )
}
